import PortalIdParser from 'PortalIdParser';
import { createClient } from 'laboratory-lib';
import experiments from '../../../experiments.yaml';
export const TreatmentsClient = {
  client: null,
  get() {
    if (!this.client) {
      this.client = createClient({
        experiments: experiments,
        identifiers: {
          portalId: PortalIdParser.get()
        }
      });
    }
    return this.client;
  }
};